import { IPageConfig } from "../../types";

let config: IPageConfig = {
    geoBaseDistance: 2.5,
    geoNumRange: [3, 5],
    geoValueRange: [0, 90],
    geoBasePosY: 2,
    cameraPosZ: 19,
    animationSpeed: 400,

}


export default config;